module.exports = __webpack_public_path__ + "img/inactive.37377de9.svg";